// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__327n1","largestCol":"styles_largestCol___n1L8","smallestCol":"styles_smallestCol__j2PgA"};